import React from 'react';
import SVGImage from '../layout/SVGImage';

interface ForecastAlertProps {
  testId?: string;
  className?: string;
  message: string;
}

export const ForecastAlert: React.FC<ForecastAlertProps> = ({
  testId,
  className,
  message,
}) => {
  return (
    <div
      data-testid={testId}
      className={`flex h-[40px] w-[240px] items-center justify-start rounded-[5px] bg-[#FFB9B9] ${className}`}
    >
      <SVGImage name="forecast-alert-edge" />
      <SVGImage
        name="error"
        fill="#B70003"
        width={16}
        height={16}
        className="ml-2"
      />
      <span className="noto-11-normal ml-2 leading-[13px] tracking-[-0.5px] text-[#7C0204]">
        {message}
      </span>
    </div>
  );
};
